import { MAX_DATE, MIN_DATE } from "static/constants";
import { DEFAULT_DATE_FORMAT } from "static/date";
import { getFormattedDate } from "utils/date";
import * as Yup from "yup";

export const generateDataPointValidationSchema = (datapointSchema) => {
  const yupSchema = {};

  for (const field of datapointSchema) {
    const { key, inputType, title } = field;

    const validations = [];

    const validationType = {
      text: Yup.string().label(title),
      number: Yup.number().label(title),
      checkbox: Yup.boolean().label(title),
      date: Yup.date()
        .label(title)
        .min(
          MIN_DATE,
          `${title} should not be before ${getFormattedDate(
            MIN_DATE,
            DEFAULT_DATE_FORMAT
          )}`
        )
        .max(
          MAX_DATE,
          `${title} should not be after ${getFormattedDate(
            MAX_DATE,
            DEFAULT_DATE_FORMAT
          )}`
        ),
    };

    validations.push(validationType[inputType]);

    yupSchema[key] =
      validations.length === 1 ? validations[0] : Yup.mixed().nullable();
  }

  return Yup.object().shape(yupSchema);
};
